import { markRaw } from 'vue'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import {
  BidStatusColumnFragmentDoc,
  BidStatusColumnFragment,
  BidActionColumnFragmentDoc,
  RateColumnBidFragmentDoc,
  RateColumnBidFragment,
} from '@/gql/graphql'
import BidStatusColumn from '@/components/GraphqlDataTable/columns/Bid/BidStatusColumn.vue'
import BidActionColumn from '@/components/GraphqlDataTable/columns/Bid/BidActionColumn.vue'
import RateColumn from '@/components/GraphqlDataTable/columns/RateColumn.vue'
import { ColumnMaps } from '@/components/GraphqlDataTable/columns/types'

const columns: ColumnMaps = {
  RateColumnBid: {
    fragment: RateColumnBidFragmentDoc,
    component: markRaw(RateColumn),
    columnDef: {
      title: $t('Your Bid'),
      key: 'bid_rate',
      colClass: { 'tw-min-w-[120px]': true },
      renderUsing: {
        component: markRaw(RateColumn),
        componentProps: (row) => ({ row }),
      },
    },
    dataDescriber: [
      {
        title: 'Rate',
        extraction: (row: RateColumnBidFragment) => `${row.rate}`,
      },
      {
        title: 'Rate type',
        extraction: (row: RateColumnBidFragment) => `${row.rateType}`,
      },
      {
        title: 'Currency',
        extraction: (row: RateColumnBidFragment) => `${row.currency}`,
      },
    ],
  },
  BidStatusColumn: {
    fragment: BidStatusColumnFragmentDoc,
    component: markRaw(BidStatusColumn),
    columnDef: {
      title: $t('Status'),
      key: 'status',
      colClass: { 'tw-whitespace-nowrap': true },
      renderUsing: {
        component: markRaw(BidStatusColumn),
        componentProps: (row) => ({ row }),
      },
    },
    dataDescriber: [
      {
        title: 'Status',
        extraction: (row: BidStatusColumnFragment) => `${row.status}`,
      },
    ],
  },
  BidActionColumn: {
    fragment: BidActionColumnFragmentDoc,
    component: markRaw(BidActionColumn),
    columnDef: {
      title: '',
      key: 'action',
      colClass: { 'tw-max-w-fit tw-w-1': true },
      renderUsing: {
        component: markRaw(BidActionColumn),
        componentProps: (row) => ({ row }),
      },
      ignoreClickForRowSelection: true,
    },
    dataDescriber: [],
  },
}

export default columns
